import { defineAsyncComponent } from 'vue'

export default app => {
  app.component('PlatformSafetyDataSheetPage', defineAsyncComponent(() => import('./SafetyDataSheetPage')))
  app.component('PlatformSafetyDataSheetSearchForm', defineAsyncComponent(() => import('./SafetyDataSheetSearchForm')))
  app.component('PlatformSafetyDataSheetSearchResults', defineAsyncComponent(() => import('./SafetyDataSheetSearchResults')))
}
